// eslint-disable-next-line
import RootRouter from "./RootRouter";

export default RootRouter;
